export const pa = {
  paQuoteSelectedPlan: (state) => {
    if (state.quotation.paForm.planNo && state.quotation.paParam.plans.plans && state.quotation.paParam.plans.plans.length > 0) {
      const selectedPlan = state.quotation.paParam.plans.plans.find(x => x.planNo === state.quotation.paForm.planNo)
      if (selectedPlan) {
        return selectedPlan
      }
    }
    return {}
  }
}
